export default {
  mainContainer: {
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    lineHeight: 1.3,
    my: '1rem',
  },
  labelContainer: {
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    mb: '1rem',
  },
  container: {},
  label: {
    textAlign: 'center',
  },

  description: {
    textAlign: 'center',
    fontSize: '12px',
  },
  askedStatusContainer: {
    alignItems: 'center',
  },
  askedStatusText: {
    textAlign: 'center',
  },
  confirmedStatusContainer: {
    alignItems: 'center',
  },
  confirmedStatusText: {},
  descriptionAdditionalService: {},
  additionalServiceContainer: {
    alignItems: 'center',
  },
  additionalServiceButton: {
    width: null,
  },
  additionalServiceButtonText: {},
  rejectedStatusContainer: {
    alignItems: 'center',
  },
  rejectedStatusText: {},

  askConfirmationButtonContainer: {
    flex: 1,
    alignItems: 'center',
  },
  askButton: {
    width: null,
    alignSelf: 'center',
  },
  disabledAskButton: {
    width: null,
    alignSelf: 'center',
  },
  askButtonText: {},
  confirmationButtonContainer: {},
  confirmButton: {
    width: null,
    alignItems: 'center',
  },
  confirmButtonText: {},
  rejectButton: {
    width: null,
  },
  rejectButtonText: {},
  termsTextContainer: {},
  termsInfo: {
    textAlign: 'center',
  },
  termsButton: {},
  emptyCartAlert: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
};
